<div class="modal-header">
  <h3 class="modal-title vox-heading-4" translate>confirmation.title</h3>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
    <i class="icon-small-close"></i>
  </button>
</div>
<div class="modal-body">
  <div class="vox-inline-message vox-inline-message_light-grey mb-3" *ngIf="hasTemporaryNumber">
    <div>
      <i class="icon-small-alert"></i>
      <span [innerHTML]="'company.dids.dids-list.popup.confirm-activate.temporary-warning' | translate"></span>
    </div>
  </div>
  <p class="vox-paragraph" translate>company.dids.dids-list.popup.confirm-activate.title</p>
  <form [formGroup]="form">
    <div class="form-group checkbox">
      <input class="vox-checkbox mr-2" type="checkbox" formControlName="isProviderApprovedVD"/>
      <label translate>company.dids.dids-list.popup.confirm-activate.q1</label>
    </div>
    <div class="form-group checkbox">
      <input class="vox-checkbox mr-2" type="checkbox" formControlName="isNumberActiveAtProvider"/>
      <label translate>company.dids.dids-list.popup.confirm-activate.q2</label>
    </div>
    <div class="form-group checkbox">
      <input class="vox-checkbox mr-2" type="checkbox" formControlName="isCallTested"/>
      <label translate>company.dids.dids-list.popup.confirm-activate.q3</label>
    </div>
    <div class="form-group checkbox" *ngIf="hasTemporaryNumber">
      <input class="vox-checkbox mr-2" type="checkbox" formControlName="isConfirmTmpNumberRemove"/>
      <label translate>company.dids.dids-list.popup.confirm-activate.q4</label>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="vox-btn vox-btn-secondary" [disabled]="form.invalid" (click)="ok()" translate>confirmation.ok</button>
</div>
